import { ModalWrapper, TextInput } from "carbon-components-react";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateBeneficiaries } from "../../actions/beneficiaries";

const defaultState = {
  beneficiary_name: "",
};

const UpdateBeneficiariesModal = ({ beneficiary }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(defaultState);

  const handleFormSubmit = () => {
    const beneficiaryObject = {
      ...form,
      id: beneficiary.id,
    };
    dispatch(updateBeneficiaries(beneficiaryObject));
    return true;
  };

  useEffect(() => {
    setForm({ ...defaultState, beneficiary_name: beneficiary.cells[0].value });
  }, [beneficiary]);

  return (
    <div style={{ padding: "1rem" }}>
      <ModalWrapper
        aria-label="Update Beneficiary Modal"
        buttonTriggerText="Update Beneficiary"
        disabled={false}
        handleSubmit={handleFormSubmit}
        hasScrollingContent={true}
        id="update-beneficiaries-modal"
        modalHeading="Update Beneficiary"
        primaryButtonText="Update"
        renderTriggerButtonIcon={undefined}
        secondaryButtonText="Cancel"
        selectorPrimaryFocus="[data-modal-primary-focus]"
        shouldCloseAfterSubmit={true}
        triggerButtonKind="ghost"
      >
        <TextInput
          id="name-updatebeneficiary"
          invalid={false}
          invalidText="A valid value is required"
          labelText="Beneficiary Name:"
          light={true}
          type="text"
          value={form.beneficiary_name}
          onChange={(e) =>
            setForm({ ...form, beneficiary_name: e.target.value })
          }
        />
      </ModalWrapper>
    </div>
  );
};

UpdateBeneficiariesModal.propTypes = {
  beneficiary: PropTypes.object,
};

export default UpdateBeneficiariesModal;
